import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from 'swiper/modules'; // Importation du module autoplay
import gsap from "gsap";
import { act, useRef, useState } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

export default function ImagesCaroussel(
    {
        images = [],
        navigation = false
    }
) {
    const swiperRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <Swiper
            className="w-full h-full overflow-hidden"
            loop={true}
            autoplay={{
                delay: gsap.utils.random(3000, 6000), // Défile toutes les 3 secondes
                disableOnInteraction: false, // Autoplay continue même après interaction
                pauseOnMouseEnter: true, // Stoppe l'autoplay au survol du curseur
            }}
            modules={[Autoplay]}
            onSwiper={(swiper) => {
                swiperRef.current = swiper;
            }}
            onSlideChange={(swiper) => {
                setActiveIndex(swiper.realIndex)
            }}
        >
            {images.map(image =>
                <SwiperSlide>
                    {image.post_slug ? <Link to={`/realisations/${image.post_slug}`}>
                        <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
                    </Link> : <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />}
                    
                </SwiperSlide>
            )}
            {(navigation && images.length > 1) && <div className="absolute bottom-0 left-0 flex justify-center items-center z-10 w-full py-8 gap-[5px]">
                {images.map((image, index) =>
                    <button onClick={() => {
                        swiperRef.current.slideTo(index);
                    }} className={clsx(
                        "w-full h-[1rem] aspect-square bg-white rounded-full transition-all",
                        index === activeIndex ? "opacity-100 max-w-[3rem]" : "opacity-50 max-w-[1rem]"
                    )}></button>
                )}
            </div>}
        </Swiper>
    )
}